"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SuperSpectrumInput = function SuperSpectrumInput(_ref) {
  var name = _ref.name,
    id = _ref.id,
    value = _ref.value,
    noColor = _ref.noColor,
    handleChange = _ref.handleChange,
    handleKeyDown = _ref.handleKeyDown,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    className: className,
    style: {
      color: "".concat(noColor ? "#151515" : "#fff")
    },
    disabled: noColor,
    type: "text",
    name: name,
    id: id,
    value: value,
    onChange: handleChange,
    onKeyDown: handleKeyDown
  }));
};
var _default = SuperSpectrumInput;
exports.default = _default;